module.exports = __webpack_public_path__ + "img/radio.371b4995.png";